import { AsyncRequest } from 'angieslist-app-platform';

export default {
  ...AsyncRequest.createActionKeys('CREATE_AND_ACTIVATE_BUSINESS_MANAGEMENT_TOOLS_SUBSCRIPTION'),
  ...AsyncRequest.createActionKeys('GET_BUSINESS_MANAGEMENT_TOOLS_AGREEMENT_ADD_ON_ELIGIBILITY'),
  ...AsyncRequest.createActionKeys('CANCEL_BUSINESS_MANAGEMENT_TOOLS_SUBSCRIPTION'),
};



// WEBPACK FOOTER //
// ./src/app/common/agreementAddOn/agreementAddOnActionKeys.js